import React from 'react';

export default function UnconfiguredSubmodulePlaceholder({ label }) {
  return (
    <div className="rounded-2xl border border-dashed border-gray-200 bg-gray-50 p-10 text-center">
      <h3 className="text-sm font-bold text-gray-700">{label}</h3>
      <p className="mx-auto mt-2 max-w-md text-sm text-gray-500">
        This submodule doesn't have a data capture form built yet. Configure its fields in the Form Registry to bring it online.
      </p>
    </div>
  );
}
